// src/pages/Home.js
import React from 'react';
import { Helmet } from 'react-helmet';
import Card from '../components/Card';
import './Home.css';
import frameImage from '../assets/AZ-min.jpg';
//import frameImage2 from '../assets/AZ.jpg';

function Home() {
  const welcomeMessage = "PROPS Yacht Consulting";

  return (
    <div className="home-container">
      <Helmet>
        <title>Home | PROPS Yacht Consulting</title>
        <meta name="description" content="Home page of PROPS Yacht Consulting" />
      </Helmet>
      <h1>{welcomeMessage}</h1>
      <div className="cards-container">
        <Card
          title="Who are we?"
          content={[
            "Arnaud Zouari", 
            "• 25 years+ of Worldwide navigation",
            "• Yacht construction (92' to 165')",
            "• Yacht refit (105' to 250')",
            "• Multiple warranty and class renewal",
          ]}
          height="700px"
          frameImage={frameImage}
          //Desktop styles
          textPosition= {{top: "80px", left: "80px"}}
          imageStyle={{
            top: '20px',
            right: '50px',
            width: '420px',
            height: '420px',
          }}
          /*secondaryFrameImage={frameImage2}
          secondaryImageStyle={{
            top: '20px',
            right: '50px',
            width: '450px',
            height: '450px',
          }}*/
          //Mobile styles
          mobileHeight="400px"
          mobileTextPosition={{top: '10px', left: '10px'}}
          mobileImageStyle={{
            top: '120px',
            right: '10px',
            width: '150px',
            height: '150px',
          }}
        />
      </div>
    </div>
  );
}

export default Home;